import { getToken } from "src/redux/selectors";

export function addTailoring(values, activateDisplayId) {
  if (activateDisplayId) {
    values.activateDisplayId = true;
  }
  return dispatch =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "sproutmanagement/api/tailoring/addtailoring",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify(values),
        }
      ).then(async res => {
        if (!res.ok) {
          return reject({ message: "Failed to add tailoring" });
        }
        return resolve(await res.text());
      });
    }).catch(err => {
      throw err.message;
    });
}

export function deleteTailoring(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "sproutmanagement/api/tailoring/deletetailoring",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({ id: id }),
        }
      )
        .then(res => {
          if (!res.ok) {
            return reject({ message: "Failed to delete tailoring" });
          }
          res.text();
        })
        .catch(async error => {
          return reject(error);
        })
        .then(async response => {
          try {
            return resolve({ message: response });
          } catch (e) {
            return reject({ message: response });
          }
        });
    }).catch(err => {
      throw err.message;
    });
}

export function findAllTailoring(access, year, months = []) {
  const baseUrl = process.env.REACT_APP_GLOBAL_SERVER + "sproutmanagement/api/tailoring/findalltailoring";

  const query = new URLSearchParams();
  if (access) query.append("access", access);
  if (year) query.append("year", year);
  // Normalize months to an array
  const normalizedMonths = Array.isArray(months) ? months : [months];
  if (normalizedMonths.length > 0) {
    query.append("months", normalizedMonths.join(","));
  }

  const url = `${baseUrl}?${query.toString()}`;

  return dispatch =>
    new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + getToken(),
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then(async res => {
          if (!res.ok) {
            return reject({ message: await res.text() });
          }
          return resolve(
            dispatch({
              type: "TAILORING_FIND_ALLTAILORING",
              data: await res.json(),
            })
          );
        })
        .catch(err => {
          throw err.message;
        });
    });
}


export function setEditTailoring(tailoring) {
  return dispatch =>
    dispatch({
      type: "TAILORING_SET_EDITTAILORING",
      data: tailoring,
    });
}

export function setTailoringDetailsId(id) {
  return dispatch =>
    dispatch({
      type: "TAILORING_SET_TAILORINGDETAILSID",
      data: id,
    });
}
